export default __webpack_public_path__ + "static/media/523.0fc9d097.jpg";